import TableShared from "@/components/TableShared/TableShared.vue";
import { mapGetters } from "vuex";

export default {
    name: 'Shared',
    components: {
        TableShared
    },
    mounted() {}
}